import BasePageProps from './BasePageProps';
import useSection from '../../hooks/useSection';
import React, { DetailedHTMLProps, HTMLAttributes } from 'react';

export default function BaseSection({sectionID, children, ...props}: BasePageProps & DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>): JSX.Element
{
  const section = useSection(sectionID);
  if (!section.active) return <></>;

  return <div {...props}>{children}</div>;
}